<template>
    <div class="px-4 py-4">
        <TabsSliderContainer :tab.sync="tab" :items="items" />
    </div>
</template>

<script>
import ContractsDebt from '@/components/debts-info/contractsDebt/ContractsDebt.vue';
import AccountsDebt from '@/components/debts-info/accountsDebt/AccountsDebt.vue';
import TabsSliderContainer from '@/components/ui/TabsSliderContainer.vue';

export default {
    name: 'DebtorsList',
    components: { TabsSliderContainer },
    data() {
        return {
            tab: null,
            items: [
                { tab: 'Задолженность по договорам юридических лиц', content: 'ContractsDebt' },
                { tab: 'Задолженность по лицевым счетам', content: 'AccountsDebt' }
            ]
        };
    },
    async created() {
        await this.$store.dispatch('refs/getDistricts');
    }
};
</script>

<style scoped lang="scss"></style>
